module.exports = __webpack_public_path__ + "img/edmbet-support.392c48f5.png";